export default {
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 12px',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    marginBottom: '0',
    fontSize: '0.875rem',
    margin: '5px 0',
    fontWeight: 400,
    color: (theme) => theme.palette.text.primary,
    '&:hover': {
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: (theme) => theme.palette.text.primary,
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays?.gray100,
      },
    },
    '&.Mui-focusVisible': {
      backgroundColor: (theme) => theme.palette.grays?.gray100,
    },
  },
  multiSelectItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '2px 6px',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    marginBottom: '0',
    fontSize: '0.875rem',
    margin: '5px 0',
    fontWeight: 400,
    color: (theme) => theme.palette.text.primary,

    '&.Mui-focused': {
      span: {
        color: (theme) => theme.palette.text.primary,
      },
      color: (theme) => theme.palette.text.primary,
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
    },
    '&[aria-selected="true"]': {
      color: (theme) => theme.palette.grays.gray700,

      backgroundColor: `white!important`,
      '&.Mui-focused': {
        span: {
          color: (theme) => theme.palette.text.primary,
        },
        color: (theme) => theme.palette.text.primary,
        backgroundColor: (theme) =>
          `${theme.palette.grays?.gray100} !important`,
      },
    },
  },
  list: {
    borderRadius: '8px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
  },
};
